import { createContext } from 'react';
import { UseDisclosureResult } from '../../../lib/hooks';

export const AddCertificatePanelContext = createContext<UseDisclosureResult | undefined>(undefined);
